// utils/dateUtils.js

/**
 * "2025年12月期" から "2025-12-31"に変更
 *
 * @param {string} periodStr - 期間の文字列（例："2025年12月期"）
 * @returns {string | null} - 変換した日付文字列（例："2025-12-31"）またはnull
 */
export const convertPeriodToFiscalYearMonth = (periodStr) => {
  const match = periodStr.match(/^(\d{4})年(\d{1,2})月期$/)
  if (!match) return null
  const year = parseInt(match[1], 10) - 1
  const month = parseInt(match[2], 10)
  const lastDay = new Date(year, month, 0).getDate()
  return `${year}-${String(month).padStart(2, '0')}-${lastDay}`
}

/**
 * 年月の末日を計算する関数
 *
 * @param {number} year - 年
 * @param {number} month - 月 (0から11の値)
 * @returns {number} - 月末日
 */
export const getLastDayOfMonth = (year, month) => new Date(year, month + 1, 0).getDate()

/**
 * 年度、決算月から画面表示する決算期を生成する関数
 *
 * @param {string} period - 決算月（例："12月"など）
 * @param {string} year - 年度（例："2024年度"）
 * @returns {string} - 表示決算期（例："2025年12月期"）
 */
export const getPeriodYm = (period, year) => {
  return (period !== '12月' ? parseInt(year.slice(0, 4)) + 1 + year.slice(4, 5) : year.slice(0, -1)) + period + '期'
}

/**
 * Dateオブジェクトを"YYYY-MM-DD"形式の文字列に整形する関数
 *
 * @param {Date | null} date - Dateオブジェクトまたはnull
 * @returns {string} - フォーマットされた日付文字列、nullの場合は空文字列を返す
 */
export const formatDateToString = (date) => {
  if (!date) return ''
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

/**
 * 日付文字列を「YYYY年M月」フォーマットに変換する関数
 *
 * @param {string} dateString - 日付文字列（YYYY-MM-DD）
 * @returns {string} - フォーマット変換した日付文字列（YYYY年M月）
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  return `${year}年${month}月`
}

/**
 * 決算期の範囲を取得する関数
 *
 * @param {string} periodString - 決算期文字列（例："2024年3月期"）
 * @returns {{ minDate: Date | null; maxDate: Date | null }} - 最小日付と最大日付
 */
export const getFiscalPeriodRange = (periodString) => {
  const match = periodString.match(/^(\d{4})年(\d{1,2})月期$/)
  if (!match) return { minDate: null, maxDate: null }

  const year = parseInt(match[1], 10)
  const fiscalMonth = parseInt(match[2], 10)

  let startYear, startMonth, endYear, endMonth, endDay

  if (fiscalMonth === 12) {
    startYear = year
    startMonth = 0 // 1月（0-index）
    endYear = year
    endMonth = 11 // 12月（0-index）
    endDay = 31
  } else {
    startYear = year - 1
    startMonth = fiscalMonth // fiscalMonthは1ベース、Dateの月は0ベースなので fiscalMonthはそのままでOK
    endYear = year
    endMonth = fiscalMonth - 1
    endDay = new Date(endYear, endMonth + 1, 0).getDate()
  }

  const minDate = new Date(startYear, startMonth, 1)
  const maxDate = new Date(endYear, endMonth, endDay)

  return { minDate, maxDate }
}
